import { CommonModule } from '@angular/common';
import { Component, inject, signal, TemplateRef } from '@angular/core';
import {
  SetupOperacionalGateService,
  TipoServicoService,
  ServicoService,
  ProfissionalService,
  EstabelecimentoDataService,
} from '@nomoh-monorepo/data-access-bardo-administrador';
import {
  BottomSheetComponent,
  DeviceService,
} from '@nomoh-monorepo/shared-common-ui';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TranslateModule } from '@ngx-translate/core';
import { EtapaProfissionaisComponent } from '../etapa-profissionais/etapa-profissionais.component';
import { EtapaServicosComponent } from '../etapa-servicos/etapa-servicos.component';
import { EtapaTiposServicoComponent } from '../etapa-tipos-servico/etapa-tipos-servico.component';

@Component({
  selector: 'lib-setup-operacional-modal',
  standalone: true,
  imports: [
    CommonModule,
    DialogModule,
    ButtonModule,
    ProgressSpinnerModule,
    BottomSheetComponent,
    EtapaTiposServicoComponent,
    EtapaServicosComponent,
    EtapaProfissionaisComponent,
    TranslateModule,
  ],
  templateUrl: './setup-operacional-modal.component.html',
  styleUrl: './setup-operacional-modal.component.scss',
})
export class SetupOperacionalModalComponent {
  gate = inject(SetupOperacionalGateService);
  deviceService = inject(DeviceService);

  private tipoServicoService = inject(TipoServicoService);
  private servicoService = inject(ServicoService);
  private profissionalService = inject(ProfissionalService);
  private estabelecimentoDataService = inject(EstabelecimentoDataService);

  activeStep = signal(1);
  preparando = signal(false);
  headerTemplate: TemplateRef<unknown> | null = null;
  footerTemplate: TemplateRef<unknown> | null = null;

  constructor() {
    void this.prepararFluxo();
  }

  private async prepararFluxo(): Promise<void> {
    this.preparando.set(true);
    try {
      const estabelecimentoId =
        this.estabelecimentoDataService.$estabelecimentoAtual()?.id;

      if (!estabelecimentoId) {
        this.activeStep.set(1);
        return;
      }

      const filtro = { estabelecimentoId };
      const [tipos, servicos, profissionais] = await Promise.all([
        this.tipoServicoService.findAll(filtro),
        this.servicoService.findAll(filtro),
        this.profissionalService.findAll(filtro),
      ]);

      if (!tipos?.length) {
        this.activeStep.set(1);
      } else if (!servicos?.length) {
        this.activeStep.set(2);
      } else if (!profissionais?.length) {
        this.activeStep.set(3);
      } else {
        this.activeStep.set(3);
      }
    } catch (error) {
      console.error('Erro ao preparar setup operacional', error);
      this.activeStep.set(1);
    } finally {
      this.preparando.set(false);
    }
  }

  irParaEtapa(step: number): void {
    this.headerTemplate = null;
    this.footerTemplate = null;
    this.activeStep.set(step);
  }

  onProfissionaisConcluidos(): void {
    this.gate.concluir();
  }

  onVisibleChange(visible: boolean): void {
    if (!visible) {
      this.fechar();
    }
  }

  headerTemplateAction(template: TemplateRef<unknown>): void {
    this.headerTemplate = template;
  }

  footerTemplateAction(template: TemplateRef<unknown>): void {
    this.footerTemplate = template;
  }

  fechar(): void {
    if (!this.gate.$visible()) {
      return;
    }
    this.headerTemplate = null;
    this.footerTemplate = null;
    this.gate.cancelar();
  }
}
